import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Profiles } from '../../models/profiles';
import { environment } from 'src/environments/environment';
const BASE_PATH = environment.basePath;

interface Permissions {
  id: string;
}

interface CreateProfileRequest {
  profile: string;
  description: string;
  permissions: Array<Permissions>;
  forceTrue: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MasterCreateProfileService {
  serviceHomeCreateProfile: any;
  constructor(private _$http: HttpClient) {}

  getProfiles() {
    return this._$http
      .get<Array<Profiles>>(
        `${BASE_PATH}/bff/master/access-profile/profiles/create/permissions/list`,
      )
      .toPromise();
  }

  checkPermissionName(payload: any): any {
    return this._$http
      .post(
        `${BASE_PATH}/bff/master/access-profile/profiles/create/verifyIfExists`, payload)
      .toPromise();
  }

  checkPermissionExists(): Promise<any> {
    return this._$http
      .get(`${BASE_PATH}/bff/master/access-profile/profiles/create/exists`)
      .toPromise();
  }

  createProfile({
    profile,
    description,
    permissions,
    forceTrue,
  }: CreateProfileRequest): Promise<any> {
    let url = `${BASE_PATH}/bff/master/access-profile/profiles/create`;

    if (forceTrue) {
      url = `${BASE_PATH}/bff/master/access-profile/profiles/create?insertDuplicated=true`;
    }

    return this._$http
      .post(url, {
        profile,
        description,
        permissions,
      })
      .toPromise();
  }
}
